/** copied from Okta examples
 * https://github.com/okta/okta-react/blob/master/samples/routing/react-router-dom-v6/src/components/SecureRoute.tsx
 **/

import React, { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Outlet, useNavigate } from 'react-router-dom'
import { LoginBackground } from './LoginBackground'
import { useSelector } from 'react-redux'
import { configurationStoreSelector } from 'selectors/storeSelectors'

export const RequiredAuth: React.FC = () => {
  const configuration = useSelector(configurationStoreSelector)
  const authentiationEnabled = !!configuration.authentication?.enabled

  if (!authentiationEnabled) return <Outlet />

  return <OktaRequiredAuth />
}

const OktaRequiredAuth = () => {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()
  const hasAuthState = !!authState

  useEffect(() => {
    if (!hasAuthState) {
      return
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin)
      oktaAuth.setOriginalUri(originalUri)
      navigate('/login')
    }
  }, [oktaAuth, hasAuthState, authState?.isAuthenticated, navigate])

  if (authState?.isAuthenticated) return <Outlet />

  return <LoginBackground />
}
